import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (P) => P.palette.common.white,
  border: (p) => `1px solid ${p.palette.primary[100]}`,
  borderRadius: (p) => p.spacing(1),
  p: (p) => p.spacing(3),
  alignItems: 'center',
};

export const total: SxStyle = {
  fontSize: (p) => p.typography.h5,
  fontWeight: 700,
  color: (P) => P.palette.common.black,
  justifyContent: 'flex-end',
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2,
  fontWeight: 500,
  color: (P) => P.palette.common.black,
};

export const percent: SxStyle = {
  color: (P) => P.palette.success[500],
  alignItems: 'center',
  display: 'flex',
  gap: (p) => p.spacing(1),

  '& p': {
    fontSize: (p) => p.typography.body2,
    fontWeight: 700,
  },
};

export const leftWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};
export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};

export const latencyWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};
